
export enum SettingsModule {
  DASHBOARD = "DASHBOARD",
  CUSTOM_FIELDS = "CUSTOM_FIELDS",
  CONTENT_SOURCES = "CONTENT_SOURCES",
  ACCOUNT_MANAGEMENT = "ACCOUNT_MANAGEMENT",
  PROFILE = "PROFILE"
}